import React, { FunctionComponent, useMemo } from 'react';
import { Image } from '@chakra-ui/react';
import { useFormContext } from '../../../../hooks';
import { CalculatorAdditionalPaymentApiResponse } from './types';
import { assetPrefix, mainMediaMobile } from '../../../../utils';
import { FormattedMessage } from 'react-intl';
import useMediaQuery from '../../../../hooks/use-media';
import { CalculatorAdditionalPaymentSummary } from './calculator-additional-payment-summary';

const CTA_MESSAGES = {
  header: {
    id: 'cta.header',
    defaultMessage: 'Hypotheek extra aflossen'
  },
  subheader: {
    id: 'cta.subheader',
    defaultMessage: `Als je (spaar)geld beschikbaar hebt, een erfenis of schenking voor de eigen woning krijgt, kan extra aflossen op je hypotheek zorgen voor lagere maandlasten. Bij een lage spaarrente kan dit een verstandige besteding zijn van het geld. Maar bedenk dat eenmaal afgelost ook betekent dat het geld in stenen zit en daarna niet meer gemakkelijk beschikbaar is. Bereken wat de nieuwe maandlasten worden nadat je eenmalig een extra aflossing heeft gedaan op je hypotheek.`
  }
};

export const CalculatorAdditionalPaymentCta: FunctionComponent = () => {
  const { result } = useFormContext<CalculatorAdditionalPaymentApiResponse>();
  const isMobile = useMediaQuery(mainMediaMobile);

  const showSummary = useMemo(() => result && !isMobile, [result, isMobile]);
  const showSubheader = useMemo(() => !result, [result]);

  return (
    <div>
      <h2 className={`mb-0 md:mb-8`}>
        <FormattedMessage {...CTA_MESSAGES.header} />
      </h2>
      {showSubheader && (
        <div className={`hidden md:block`}>
          <div>
            <FormattedMessage {...CTA_MESSAGES.subheader} />
          </div>
          <Image w={`364px`} src={`${assetPrefix}/assets/shared/images/cta.png`} />
        </div>
      )}
      {showSummary && (
        <CalculatorAdditionalPaymentSummary result={result}></CalculatorAdditionalPaymentSummary>
      )}
    </div>
  );
};
